export default __webpack_public_path__ + "static/media/plus-activation.396dda5e.svg";